// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rlpithtsgnxmqrbmzirj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJscGl0aHRzZ254bXFyYm16aXJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk1MTg3MjcsImV4cCI6MjA2NTA5NDcyN30.FYWfZGrGLS56fqyaPcR80xroPHShidHjpG6435OkPtE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);